import React from 'react'
import { useParams } from 'react-router'
import { Toast } from './../UI/toast/Toast'
import { create } from '../../helpers/api/banks'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import withRedirect from '../../helpers/hoc/withRedirect'
import PageHeader from '../common/PageHeader'
import CreateBankForm from './CreateBankForm'
import SupportLink from '../root/support/components/SupportLink'

const CreateBank = ({ setRedirectUrl, setRedirect }) => {

    const { id } = useParams();

    const handleSubmitData = async (values) => {
        try {
            const response = await create(values)
            if (response.code === SUCCESS_RESPONSE.CREATED) {
                Toast.fire({
                    type: 'success',
                    title: `Se ha creado el banco satisfactoriamente.`,
                });
                setRedirectUrl(`/dashboard/banks`);
                setRedirect(true);
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    return <>
        <PageHeader
            title="Crear nuevo banco"
            titleTag="h2"
            description="Crea un nuevo banco y gestionalo al instante."
            className="mb-3"
            col={{ lg: 9 }}
        >
            <SupportLink />
        </PageHeader>
        <CreateBankForm handleSubmitData={handleSubmitData} condominiumId={id} />
    </>
}

export default withRedirect(CreateBank);